<template>
    <section>
        <div class="container">
            <template v-if="hasPermission">
                <div class="mb-10">
                    <div class="tab" v-if="model">
                        <a v-on:click.prevent="currentManagementTab = ManagementTab.MANAGEMENT" href=""
                           :class="{'active': currentManagementTab == ManagementTab.MANAGEMENT}">
                            {{translate('bestuurd_door')}}
                            <span class="badge badge-xs ml-1" :class="{'active': currentManagementTab == ManagementTab.MANAGEMENT}">{{ model.huidigeBedrijfsleiding.length }}</span>
                        </a>
                        <a v-on:click.prevent="currentManagementTab = ManagementTab.MANDATES" href=""
                           :class="{'active': currentManagementTab == ManagementTab.MANDATES}">
                            {{translate('bestuurder_in')}}
                            <span class="badge badge-xs ml-1" :class="{'active': currentManagementTab == ManagementTab.MANDATES}">{{ model.mandaten.length }}</span>
                        </a>
                        <a class="mobile:!hidden"
                           v-on:click.prevent="currentManagementTab = ManagementTab.EXTERN"
                           href=""
                           :class="{'active': currentManagementTab == ManagementTab.EXTERN}">
                            {{translate('external_members')}}
                            <span class="badge badge-xs ml-1" :class="{'active': currentManagementTab == ManagementTab.EXTERN}">{{ model.huidigeExterneBestuurders.length }}</span>
                        </a>
                    </div>
                </div>
                <div v-if="!!model">
                    <div v-if="currentManagementTab == ManagementTab.MANAGEMENT" class="space-y-10">
                        <div>
                            <h2 class="font-medium text-md mobile:text-base">{{translate('huidige_bedrijfsleiding')}}</h2>
                            <directors-table :mandate-holders="currentMandateHolders" :is-regsol="detailStore.isRegsol" :has-access-to-mandates="hasAccessToMandates" :is-instituut="isInstituut" :cw-id="cwId" :can-see-scores="canSeeScores" :current-vat="currentVat"></directors-table>
                        </div>

                        <div v-if="model.vorigeBedrijfsleiding.length > 0">
                            <h2 class="font-medium text-md mobile:text-base">{{translate('vorige_bedrijfsleiding')}}</h2>
                            <directors-table :mandate-holders="historicMandateHolders" :is-regsol="detailStore.isRegsol" :has-access-to-mandates="hasAccessToMandates" :is-instituut="isInstituut" :cw-id="cwId" :can-see-scores="canSeeScores" :current-vat="currentVat"></directors-table>
                        </div>
                    </div>

                    <div v-if="currentManagementTab == ManagementTab.MANDATES" class="space-y-10">
                      <template v-if="hasAccessToMandates">
                          <div>
                              <h2 class="font-medium text-md mobile:text-base">{{translate('mandaten')}}</h2>
                              <mandates-table :mandaten="model.mandaten" :can-see-scores='canSeeScores'></mandates-table>
                          </div>
                      </template>
                        <template v-else>
                           <no-access :subPage="SubPage.DIRECTORS"></no-access>
                        </template>
                    </div>

                    <div v-if="currentManagementTab == ManagementTab.EXTERN">
                        <h2 class="font-medium text-md mobile:text-base">{{translate('external_members')}}</h2>
                        <directors-table :mandate-holders="[model.huidigeExterneBestuurders]" :can-see-scores="canSeeScores" :has-access-to-mandates="hasAccessToMandates" :cw-id="cwId" :is-instituut="isInstituut" :current-vat="currentVat"></directors-table>
                    </div>
                </div>
            </template>
            <no-access v-else :sub-page="detailStore.SubPage.DIRECTORS"></no-access>
        </div>
    </section>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useDetailStore} from "../store";
import {DirectorModel, IMandateHolder, SubPage} from '../types';
import DirectorsTable from "./directors/directors-table.vue";
import MandatesTable from "./directors/mandates-table.vue";
import NoAccess from "./no-access.vue";
import {Feature} from "../../../types/dto/Feature";

enum ManagementTab {
    MANAGEMENT,
    MANDATES,
    EXTERN
}

export default defineComponent({
    name: "directors",
    components: {NoAccess, DirectorsTable, MandatesTable},
    data() {
        return {
            SubPage,
            Feature,
            detailStore: useDetailStore(),
            currentManagementTab: ManagementTab.MANAGEMENT,
            ManagementTab,
        }
    },
    computed: {
        hasPermission(): boolean {
            return this.detailStore.canSeePaidComponents;
        },
        isInstituut(): boolean {
            return this.detailStore.isInstituut;
        },
        canSeeScores(): boolean {
            return this.store.permissions[Feature.LINKED_BAROMETERS];
        },
        hasAccessToMandates(): boolean {
            return this.store.permissions[Feature.MANDATES];
        },
        model(): DirectorModel {
            return this.detailStore.pageModel[SubPage.DIRECTORS]!;
        },
        currentVat(): number {
            return this.detailStore.vat;
        },
        cwId(): string {
            return this.detailStore.cwId;
        },
        groupedByHolder() {
            return this.model.huidigeEnVorigeBedrijfsleiding.groupBy(m => m.mandateHolderId ?? m.holder);
        },
        currentMandateHolders(): IMandateHolder[][] {
            return Array.from(this.groupedByHolder.values()).filter(holders => holders.some(h => h.isHuidig));
        },
        historicMandateHolders(): IMandateHolder[][] {
            return Array.from(this.groupedByHolder.values()).filter(holders => holders.every(h => !h.isHuidig));
        }
    },
    mounted() {
        if (this.detailStore.currentSubPage === SubPage.MANDATES)
            this.currentManagementTab = ManagementTab.MANDATES;
        else if (this.detailStore.currentSubPage === SubPage.EXTERN)
            this.currentManagementTab = ManagementTab.EXTERN;
    }
});
</script>